import React, { useEffect, useState, createContext, useContext } from 'react';

interface ResultJSONType
{
	[ key: string ]: any;
}

const ResultJSONContext = createContext<ResultJSONType | null>( null );
const ResultJSONBucketBaseURLContext = createContext<string>( "" );

export const ResultJSON = ({ bucketBaseURL, code, children }: { bucketBaseURL?: string, code: string, children: React.ReactNode } ) => {
	const [ jsonData, setJsonData ] = useState<ResultJSONType | null>( null );
	const [ bucketBaseURLData, setBucketBaseURLData ] = useState<string>( "" );

	useEffect(
		() =>
		{
			const fetchData = async () => {
				try {
					/*
					* NOTE:
					* using S3 bucket
					*  https://fipok-result.s3.eu-central-1.amazonaws.com
					* as default
					*/
					//deprecated	const url = `${window.location.origin}/api/result/${code}.json`;
					//https://fipok-result.s3.eu-central-1.amazonaws.com
					const baseURL = bucketBaseURL === undefined
						? "https://fipok-result.s3.eu-central-1.amazonaws.com"
						: ( bucketBaseURL.startsWith( 'http' ) ? bucketBaseURL : `https://${bucketBaseURL}` );
					setBucketBaseURLData( baseURL );
					const url = `${baseURL}/${code}.json`;
					const response = await fetch( url );
					const data = await response.json();
					setJsonData( data );
				} catch ( error ) {
					console.log('ResultJSON: Error fetching data:', error );
				}
			};
			fetchData();
		},
		[
			bucketBaseURL,
			code
		]
	);

	// Render the component or components that will use the JSON data
	return (
		<ResultJSONContext.Provider value = {jsonData}>
			<ResultJSONBucketBaseURLContext.Provider value = {bucketBaseURLData}>
				{children}
			</ResultJSONBucketBaseURLContext.Provider>
		</ResultJSONContext.Provider>
      	);
};

export default ResultJSON;
export const useResultJSON = () => useContext( ResultJSONContext );
export const useResultJSONBucketBaseURL = () => useContext( ResultJSONBucketBaseURLContext );